import React, { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Link } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import robotImg from '@/assets/robot.png';
import { CLIENT_ID_BLOOMKEEP } from '@/lib/constants';

const formatLongDate = (d: Date) =>
  d.toLocaleDateString('es-AR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

const StatCard: React.FC<{ label: string; value: string | number; to: string }>
  = ({ label, value, to }) => (
    <Link to={to} className="panel-card block p-6 hover:shadow-lg transition-shadow">
      <div className="text-slate-500 text-sm mb-2">{label}</div>
      <div className="text-5xl font-semibold text-slate-800">{value}</div>
      <div className="mt-4 text-sm text-indigo-600">Ver detalles →</div>
    </Link>
  );

const PanelDashboard: React.FC = () => {
  const { user } = useAuth();
  const [eventsCount, setEventsCount] = useState<string | number>('—');
  const [clientsCount, setClientsCount] = useState<string | number>('—');

  useEffect(() => {
    const load = async () => {
      try {
        const { count: albumsCount } = await supabase
          .from('albums')
          .select('id', { count: 'exact', head: true });
        if (typeof albumsCount === 'number') setEventsCount(albumsCount);
      } catch (e) {
        console.error(e);
      }
      try {
        const { count, error } = await supabase
          .from('clients')
          .select('id', { count: 'exact', head: true })
          .neq('id', CLIENT_ID_BLOOMKEEP);
        if (!error && typeof count === 'number') {
          setClientsCount(count);
        } else {
          setClientsCount('—');
        }
      } catch {
        setClientsCount('—');
      }
    };
    load();
  }, []);

  const today = new Date();
  type UserMeta = { name?: string; full_name?: string };
  const meta = (user?.user_metadata ?? {}) as UserMeta;
  const fullName = meta.name || meta.full_name || user?.email?.split('@')[0] || 'Usuario';
  const firstName = String(fullName).split(' ')[0];

  return (
    <div className="space-y-6">
      {/* Hero */}
      <div className="panel-card p-6 sm:p-8 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, rgba(163,76,255,0.9), rgba(86,77,255,0.9))' }}>
        <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
          <div className="text-white">
            <div className="text-sm opacity-90 mb-2">{formatLongDate(today)}</div>
            <h2 className="text-3xl sm:text-4xl font-bold mb-2">¡Hola, {firstName}!</h2>
            {/* <p className="opacity-90">Power user</p> */}
          </div>
          <div className="justify-self-end hidden md:block">
            <img src={robotImg} alt="Robot" className="w-[230px] relative top-5 h-auto drop-shadow" />
          </div>
        </div>
        <div className="absolute -right-12 -top-12 w-72 h-72 rounded-full bg-white/10" />
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <StatCard label="Eventos" value={eventsCount} to="/panel/eventos/listado" />
        <StatCard label="Clientes" value={clientsCount} to="/panel/clientes" />
      </div>
    </div>
  );
};

export default PanelDashboard;
